import React from 'react';
import './AdComponent.css';

const AdComponent = ({ imageUrl, link }) => {
  return (
    <div className="ad-component">
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={imageUrl} alt="Advertisement" />
      </a>
    </div>
  );
};

export default AdComponent;
